export interface TeamMember {
  name: string;
  role: string;
  photo: string;
}

export interface LeadershipMember extends TeamMember {
  bio: string;
  color: string;
}

export const leadership: LeadershipMember[] = [
  {
    name: "Nabeel Imdad",
    role: "Co-Founder & Creative Director",
    bio: "A passionate graphic designer with an eye for detail and a love for creating brands that stand out. Nabeel leads the creative vision at Dev Cubix, ensuring every pixel serves a purpose.",
    photo: "/assets/team/dps/dp_Nabeel Imdad.jpg",
    color: "#E11D24",
  },
  {
    name: "Bilal Ahmad",
    role: "Co-Founder & Tech Lead",
    bio: "A full-stack developer who turns designs into blazing-fast, scalable applications. Bilal architects the technical backbone of every project — from React frontends to AI-powered solutions.",
    photo: "/assets/team/dps/dp_Bilal Ahmad.jpg",
    color: "#E11D24",
  },
  {
    name: "Zeerak Ali",
    role: "Business Partner",
    bio: "Driving strategic partnerships and business growth. Zeerak connects DevCubix with clients across the globe and ensures every project aligns with business objectives.",
    photo: "/assets/team/dps/dp_Zeerak Ali.jpg",
    color: "#E11D24",
  },
  {
    name: "Hamza Imdad",
    role: "Partner & Design Analyst",
    bio: "Bridging the gap between design and strategy. Hamza analyzes design trends, manages the creative pipeline, and ensures quality delivery across all projects.",
    photo: "/assets/team/dps/dp_Hamza Imdad.jpg",
    color: "#E11D24",
  },
];

export const designTeam: TeamMember[] = [
  { name: "Muhammad Nouman", role: "Graphic Design Team Lead", photo: "/assets/team/dps/dp_Muhammad Nouman.jpg" },
  { name: "Faizan Iqbal", role: "Senior Graphic Designer", photo: "/assets/team/dps/dp_Faizan Iqbal.jpg" },
  { name: "Fareed Ahmad", role: "Graphic Designer", photo: "/assets/team/dps/dp_Fareed Ahmad.jpg" },
  { name: "Farhan Ali", role: "Graphic Designer", photo: "/assets/team/dps/dp_Farhan Ali.jpg" },
  { name: "Jawad Ali", role: "Graphic Designer", photo: "/assets/team/dps/dp_Jawad Ali.jpg" },
  { name: "Nimra Rasheed", role: "Graphic Designer", photo: "/assets/team/dps/dp_Nimra Rasheed.png" },
  { name: "Husain", role: "Graphic Designer", photo: "/assets/team/dps/dp_Husain.jpg" },
  { name: "Shahzaib", role: "Graphic Designer", photo: "/assets/team/dps/dp_Shahzaib.jpg" },
  { name: "Soban Shafiq", role: "UI/UX Designer", photo: "/assets/team/dps/dp_Soban Shafiq.jpg" },
  { name: "Adeel Rehman", role: "Graphic Designer", photo: "/assets/team/dps/dp_Adeel Rehman.jpg" },
  { name: "Fahad Rauf", role: "Graphic Designer", photo: "/assets/team/dps/dp_Fahad Rauf.jpg" },
  { name: "Flame", role: "Graphic Designer", photo: "/assets/team/dps/dp_Flame.jpg" },
  { name: "Huzaifa Tasawar", role: "Graphic Designer", photo: "/assets/team/dps/dp_Huzaifa Tasawar.jpg" },
  { name: "Zohaib", role: "Graphic Designer", photo: "/assets/team/dps/dp_Zohaib.jpg" },
  { name: "Usama Farooq", role: "Graphic Designer", photo: "/assets/team/dps/dp_Usama Farooq.jpg" },
  { name: "Waqas Rahim", role: "Graphic Designer", photo: "/assets/team/dps/dp_Waqas Rahim.jpg" },
];

export const presentationTeam: TeamMember[] = [
  { name: "Areena Javed", role: "Presentation Designer", photo: "/assets/team/dps/dp_Areena Javed.jpg" },
  { name: "Laiba", role: "Slide Deck Designer", photo: "/assets/team/dps/dp_Laiba.png" },
  { name: "Ammara", role: "Slide Deck Designer", photo: "/assets/team/dps/dp_Ammara.png" },
  { name: "Alta", role: "Slide Deck Designer", photo: "/assets/team/dps/dp_Alta.png" },
  { name: "Delta", role: "Slide Deck Designer", photo: "/assets/team/dps/dp_Delta.png" },
];

export const devTeam: TeamMember[] = [
  { name: "Osama Ali", role: "Sr. WordPress Developer", photo: "/assets/team/dps/dp_Osama Ali.png" },
  { name: "Muhammad Ajmal", role: "WordPress Developer", photo: "/assets/team/dps/dp_Muhammad Ajmal.jpg" },
  { name: "Muhammad Abdullah", role: "Framer Developer", photo: "/assets/team/dps/dp_Muhammad Abdullah.jpg" },
];

export const businessTeam: TeamMember[] = [
  { name: "Syed Haider Ali", role: "Business Developer", photo: "/assets/team/dps/dp_Syed Haider Ali.jpg" },
  { name: "Aftab", role: "Business Developer", photo: "/assets/team/dps/dp_Aftab.jpg" },
  { name: "Hasnain Ziafat", role: "Senior Business Developer", photo: "/assets/team/dps/dp_Hasnain Ziafat.jpg" },
];

export const csrTeam: TeamMember[] = [
  { name: "Afaq Satti", role: "Senior CSR", photo: "/assets/team/dps/dp_Afaq Satti.jpg" },
  { name: "Waleed Shoukat Abbasi", role: "Customer Support", photo: "/assets/team/dps/dp_Waleed Shoukat Abbasi.jpg" },
  { name: "Esha", role: "Customer Support", photo: "/assets/team/dps/dp_Esha.jpg" },
  { name: "Hassan Zohrab Abbasi", role: "Customer Support", photo: "/assets/team/dps/dp_Hassan Zohrab Abbasi.jpg" },
  { name: "Dua", role: "Customer Support", photo: "/assets/team/dps/dp_Dua.jpg" },
];

export const opsTeam: TeamMember[] = [
  { name: "Nimra Kanwal", role: "Senior HR", photo: "/assets/team/dps/dp_Nimra Kanwal.png" },
  { name: "Saniya Rizwan", role: "Social Media Manager", photo: "/assets/team/dps/dp_Saniya Rizwan.png" },
  { name: "Mahnoor Asif", role: "Technical Writer", photo: "/assets/team/dps/dp_Mahnoor Asif.png" },
  { name: "Malaika", role: "Assistant Manager", photo: "/assets/team/dps/dp_Malaika.png" },
  { name: "Sibgha Malik", role: "HR", photo: "/assets/team/dps/dp_Sibgha Malik.png" },
  { name: "Khushbakht Noor", role: "Social Media Executive", photo: "/assets/team/dps/dp_Khushbakht Noor.png" },
];
